import { ok } from '@xlearn/common';
import { setCMIString1000 } from './cmi-string.actions';

export function getLocation(location: string) {
  return ok(location);
}

export function setLocation(current: string, value: string) {
  return setCMIString1000(current, value);
}

